export const LogoSvg = ({
  width,
  height,
}: {
  width: string;
  height: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 483 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M420.913 98.6117C417.913 98.6117 415.33 98.1169 413.163 97.1326C410.997 96.1482 409.32 94.7472 408.143 92.9242C406.976 91.0909 406.393 88.9555 406.393 86.5076H414.372C414.372 88.2055 414.955 89.5284 416.122 90.4867C417.299 91.4451 418.882 91.9242 420.872 91.9242C422.58 91.9242 423.924 91.5909 424.913 90.9242C425.898 90.2576 426.393 89.3305 426.393 88.1326C426.393 86.8722 425.794 85.8513 424.601 85.0701C423.403 84.2784 421.544 83.6117 419.018 83.0701C414.82 82.1847 411.715 80.8357 409.705 79.0284C407.705 77.2263 406.705 74.8722 406.705 71.9659C406.705 68.7055 407.893 66.1274 410.268 64.2367C412.653 62.3357 415.919 61.3826 420.059 61.3826C422.877 61.3826 425.33 61.8722 427.413 62.8409C429.497 63.8149 431.106 65.1847 432.247 66.9451C433.382 68.6951 433.955 70.7784 433.955 73.1951H426.143C426.143 71.6013 425.606 70.3409 424.538 69.4242C423.481 68.4972 422.018 68.0284 420.143 68.0284C418.445 68.0284 417.101 68.3617 416.101 69.0284C415.111 69.6951 414.622 70.6274 414.622 71.8201C414.622 72.919 415.163 73.8409 416.247 74.5909C417.34 75.3409 419.257 76.0388 421.997 76.6742C426.455 77.7315 429.669 79.1482 431.643 80.9242C433.627 82.7055 434.622 85.0024 434.622 87.8201C434.622 91.1951 433.398 93.8409 430.955 95.7576C428.523 97.6638 425.174 98.6117 420.913 98.6117Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M141.253 37.2292C137.545 37.2292 134.243 36.4375 131.358 34.8542C128.483 33.2708 126.233 31.0833 124.608 28.2917C122.993 25.4896 122.191 22.2656 122.191 18.625C122.191 14.974 122.993 11.75 124.608 8.95833C126.233 6.15625 128.483 3.95833 131.358 2.375C134.243 0.791667 137.545 0 141.253 0C145.003 0 148.306 0.791667 151.17 2.375C154.045 3.95833 156.295 6.15625 157.92 8.95833C159.556 11.75 160.378 14.974 160.378 18.625C160.378 22.2656 159.556 25.4896 157.92 28.2917C156.295 31.0833 154.045 33.2708 151.17 34.8542C148.306 36.4375 145.003 37.2292 141.253 37.2292ZM130.462 18.625C130.462 20.7656 130.92 22.6563 131.837 24.2917C132.764 25.9323 134.035 27.2188 135.649 28.1458C137.274 29.0625 139.139 29.5208 141.253 29.5208C143.404 29.5208 145.285 29.0625 146.899 28.1458C148.524 27.2188 149.785 25.9323 150.691 24.2917C151.592 22.6563 152.045 20.7656 152.045 18.625C152.045 16.474 151.592 14.5781 150.691 12.9375C149.785 11.3021 148.524 10.0208 146.899 9.10417C145.285 8.1875 143.404 7.72917 141.253 7.72917C139.139 7.72917 137.274 8.1875 135.649 9.10417C134.035 10.0208 132.764 11.3021 131.837 12.9375C130.92 14.5781 130.462 16.474 130.462 18.625Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M87.1921 36.5209L73.4421 0.708374H82.1921L86.9421 13.4584L91.2338 24.8125L100.255 0.708374H108.942L95.1713 36.5209H87.1921Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M461.156 97.9034V85.3826L447.969 62.0909H457.219L461.677 70.3826L465.261 76.8826L468.781 70.3826L473.177 62.0909H482.448L469.302 85.2784V97.9034H461.156Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M177.461 36.5209V0.708374H185.607V36.5209H177.461Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M221.188 37.2292C217.573 37.2292 214.365 36.4375 211.563 34.8542C208.771 33.2708 206.589 31.0833 205.021 28.2917C203.464 25.4896 202.688 22.2656 202.688 18.625C202.688 14.974 203.464 11.75 205.021 8.95833C206.589 6.15625 208.761 3.95833 211.542 2.375C214.334 0.791667 217.532 0 221.146 0C224.172 0 226.948 0.583333 229.48 1.75C232.006 2.90625 234.131 4.53646 235.855 6.64583C237.573 8.76042 238.777 11.25 239.459 14.125H231.063C230.381 12.1406 229.172 10.5781 227.438 9.4375C225.698 8.30208 223.688 7.72917 221.396 7.72917C219.381 7.72917 217.584 8.1875 216 9.10417C214.417 10.0208 213.178 11.3021 212.292 12.9375C211.402 14.5781 210.959 16.474 210.959 18.625C210.959 20.7656 211.402 22.6563 212.292 24.2917C213.178 25.9323 214.407 27.2188 215.98 28.1458C217.547 29.0625 219.339 29.5208 221.355 29.5208C223.698 29.5208 225.756 28.9167 227.521 27.7083C229.297 26.4896 230.563 24.8542 231.313 22.8125H239.709C239.125 25.7188 237.964 28.25 236.23 30.4167C234.49 32.5833 232.334 34.2656 229.75 35.4583C227.178 36.6354 224.323 37.2292 221.188 37.2292Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M256.628 36.5209V0.708374H280.17V7.56254H264.712V14.9792H278.774V21.7917H264.712V29.625H280.732V36.5209H256.628Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M318.937 97.9034V62.0909H342.479V68.9451H327.02V76.3618H341.083V83.1743H327.02V91.0076H343.041V97.9034H318.937Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M356.682 97.9034L370.911 62.0909H378.89L393.098 97.9034H384.411L381.994 91.7159H367.786L365.369 97.9034H356.682ZM369.869 85.3201H379.952L374.89 72.2368L369.869 85.3201Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M27.3107 36.5209V0.708374H34.2273L50.019 22.5V0.708374H58.1023V36.5209H51.2065L35.394 14.5834V36.5209H27.3107Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M130.334 72.1335H288.714V89.7429H130.334V72.1335Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M309.281 10.748H467.662V28.3626H309.281V10.748Z"
        className="fill-black dark:fill-white"
      />
      <path
        d="M0 36.5209V0.708374H8.14583V36.5209H0Z"
        className="fill-black dark:fill-white"
      />
    </svg>
  );
};
